var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelmet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1V6",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22228 3.92578C6.24085 4.21842 5.33757 4.75157 4.60028 5.48886C3.43339 6.65576 2.77783 8.2384 2.77783 9.88864L15.2223 9.88864C15.2223 8.2384 14.5667 6.65576 13.3998 5.48887C12.6625 4.75157 11.7593 4.21842 10.7778 3.92578V6.51825C10.7778 7.33645 9.98189 7.99973 9.00005 7.99973C8.01821 7.99973 7.22228 7.33645 7.22228 6.51825V3.92578Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 9.77734,
    width: 2.66667,
    height: 16,
    rx: 1.33333,
    transform: "rotate(90 17 9.77734)",
    stroke: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelmet);
export default __webpack_public_path__ + "static/media/helmet.cd84d88f.svg";
export { ForwardRef as ReactComponent };